<template>
  <div v-if="requests.length"
       class="requests"
       @click="openManageRequestsPage">
    <icon-question  height="40"
                    width="40"
                    iconColor="#fff" />
    <div class="requests-amount"
         :class="amountClasses">
      {{ requestsAmount }}
    </div>
  </div>
</template>

<script>
  export default {
    computed: {
      ...mapGetters('requests', [
        'requests'
      ]),

      requestsAmount() {
        return this.requests.length > 99 ? '+99' : this.requests.length
      },

      amountClasses() {
        return {
          'requests-amount-large': this.requests.length > 99
        }
      }
    },

    methods: {
      openManageRequestsPage() {
        this.$router.push({
          name: 'manageRequests'
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  .requests {
    height: auto;
    width: auto;
    position: relative;

    display: flex;
    align-items: center;
    justify-content: center;

    background: transparent;
    cursor: pointer;

    .requests-amount {
      width: 18px;
      height: 18px;

      display: flex;
      align-items: center;
      justify-content: center;

      padding-top: 3px;
      font-size: 12px;
      background: #fff;
      color: map-get($colors, primary);
      border: 2px solid map-get($colors, primary);
      border-radius: 50%;

      position: absolute;
      top: -3px;
      right: -3px;

      &-large {
        width: 25px;
        border-radius: 9px;

        right: -10px;
      }
    }
  }
</style>